import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";



import { UserManagementService } from '@/services/user-management/user-management.service';
import { UserService } from '@/services/user/user.service';
import { UserPass } from '@/interface/User';
import { userpass } from 'src/app/class/userpass';
// import { UserPass } from '@/interface/User';


@Component({
  selector: 'app-forgot-resetpassword',
  templateUrl: './forgot-resetpassword.component.html',
  styleUrls: ['./forgot-resetpassword.component.scss']
})
export class ForgotResetpasswordComponent implements OnInit {
  id = localStorage.getItem("UserId");
  password: any;
  passwordconfirm: any;
  canNotSave = true;
  userpass = new UserPass()
  resettoken : any;

  constructor(
    public userManagementService: UserManagementService,
    private router: Router,
    private userService: UserService,
    private activateRoute: ActivatedRoute,
    // private userpass: UserPass

  ) {}

  ngOnInit(): void {}


  onSavePassword() {
    if (this.password != this.passwordconfirm) {
      Swal.fire({
        title: "Passwords do not match",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: "Do you want to save new password?",
        showCancelButton: true,
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
         // localStorage.setItem("checkFirstTime", "reset");
          this.userService
            .resetPassword(this.password,this.resettoken)
            .subscribe((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Password changed successfully",
                showConfirmButton: false,
                timer: 1000,
              });
              
            });
        }
      });
    }
  }

  onResetPassword() {
    if (
      this.password == undefined ||
      this.passwordconfirm == undefined ||
      this.password.trim().length < 8 ||
      this.passwordconfirm.trim().length < 8
    ) {
      this.canNotSave = true;
    } else {
      this.canNotSave = false;
    }
  }

  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (!/[ก-๙]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onBack() {
    this.router.navigate(["login"]);
  }

  checknewpassword(data,dataconfirm){
    this.activateRoute.queryParams.subscribe((data)=>{
      console.log("hihi " ,data);
      this.resettoken = data.token
      
    })
    // this.userpass.password = data
    // let urlToken = "58e54376-67d0-4544-82a9-84f791d90ecc"
    // this.userpass.resetToken = urlToken 
    // let datatoken = [data,urlToken]
    // console.log( " check " , this.userpass )
    
    if (data == dataconfirm){
      this.userpass.password = data
      this.userService
      .resetPassword(data,this.resettoken)
      .subscribe((res)=>{
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Password changed successfully",
          showConfirmButton: false,
          timer: 1000,
          });
          setTimeout(() => {
          this.router.navigate(["login"]);
          }, 1000);
          });
      
      
      
    
      
      
      // this.userService.resetPassword(datatoken)
      console.log(" Correct ") 
    }else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Password not match!",
      })
      
    }
    

  }
}

